const initialState = {
    OTList: [],    
    OT1: [],  
    loading: false,
  };
  
  export const OTDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FETCH_OTDETAILS_REQUEST":
        return { ...state, loading: true };
      case "FETCH_OTDETAILS_SUCCESS":
        return { ...state, OTList: action.payload, loading: false };
      case "FETCH_OTDETAILS_FAILURE":
        return { ...state, loading: false };
      default:
        return state; // Always return state
    }
  };
  
  //  export const otdReducer = (state = initialState, action) => {
  //     switch (action.type) {
  //       case "FETCH_OTDETAILS1_REQUEST":
  //         return { ...state, loading: true };
  //       case "FETCH_OTDETAILS1_SUCCESS":
  //         //console.log("doo",action.payload);
  //         return { ...state, OT1: action.payload, loading: false };
  //       case "FETCH_OTDETAILS1_FAILURE":
  //         return { ...state, loading: false };
  //       default:
  //         return state; // Always return state
  //     }
  //   };
  